<script lang="ts">
const __DsBlock = {
	hidden: true,
	category: 'file-preview',
	tags: ['application/pdf'],
	events: [
		{
			name: 'remove',
			payload: [],
		},
	],
}
</script>
<script lang="ts" setup>
import type { FilePreviewBlockEmits, FilePreviewBlockProps } from '#layers/assets/types/file-preview';
import { defineAsyncComponent } from 'vue';
import { useAppConfig } from '#app/config';
import { useFileCollection, useProjectAssetURL } from '#imports';
import { defineBlock } from '#layers/block-engine';

const { file, showRemove = true } = defineProps<FilePreviewBlockProps>();
defineEmits<FilePreviewBlockEmits>();

const LazyPdfPreviewDocument = defineAsyncComponent(() => import('#layers/assets/components/PdfPreview/PdfPreviewDocument.vue'));

;

const appConfig = useAppConfig();
const assetURL = useProjectAssetURL(() => file);
const { collection } = useFileCollection();
</script>

<template>
	<div class="relative flex max-h-[500px] flex-col overflow-hidden rounded-lg border bg-default">
		<header class="flex w-full items-center justify-between border-b px-3 py-2 text-sm font-medium">
			<RenderCollectionDisplayTemplate :collection-id="collection!.id" :item="file" />
			<DTooltip v-if="showRemove" :text="$t('common.remove')">
				<DButton variant="ghost" color="neutral" size="sm" :icon="appConfig.ui.icons.remove" @click="$emit('remove')" />
			</DTooltip>
		</header>
		<LazyPdfPreviewDocument :source="assetURL" class="flex-1" />
	</div>
</template>
